module.exports = __webpack_public_path__ + "img/clipboard-minus.53fbc183.svg";